import { z } from "zod";

export const emailSchema = z
  .string()
  .nonempty("Email is required.")
  .email("Email must be in a valid format.")
  .refine((email) => !email.includes(" "), {
    message: "Email cannot contain spaces.",
  })
  .refine(
    (email) => {
      const domain = email.split("@")[1];
      if (!domain) return false;

      const domainParts = domain.split(".");
      return domainParts.every((part) => !part.endsWith("-"));
    },
    {
      message: "Please enter a valid email address.",
    },
  );
